export default "__VITE_ASSET__DazLEuvy__"